function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.7449 47.6648C40.6397 48.7769 38.023 49.3312 34.8937 49.3312H25.0787V60.5889H20.9824V33.0352H35.3623C43.0435 33.0352 46.8841 35.785 46.8841 41.2848C46.8841 44.1025 45.5032 46.2292 42.7449 47.6648ZM35.6192 36.5713H25.0799V45.7963H35.662C37.7102 45.7963 39.3742 45.4168 40.654 44.6592C42.0479 43.8456 42.7449 42.7359 42.7449 41.3265C42.7449 38.1555 40.3697 36.5713 35.6192 36.5713Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7422 60.5898V33.0361H55.8397V60.5898H51.7422Z",
  fill: "#333333"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M85.3672 60.5899L65.8229 39.2127V60.5899H61.7266V33.0361H65.3959C67.871 35.8538 71.1573 39.4577 75.2536 43.8466C80.2039 49.13 83.4463 52.6113 84.983 54.292V33.0373H89.0793V60.5911H85.3672V60.5899Z",
  fill: "#333333"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M106.579 34.3766V60.5898H105.043V34.3766H93.9482V33.0361H117.63V34.3766H106.579Z",
  fill: "#86BCC2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M147.074 60.5898V46.8534H125.354V60.5898H123.819V33.0361H125.354V45.5534H147.074V33.0361H148.611V60.5898H147.074Z",
  fill: "#86BCC2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M157.104 60.5898V33.0361H178.482V34.3766H158.597V45.5522H176.221V46.8534H158.597V59.2482H178.695V60.5898H157.104Z",
  fill: "#86BCC2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M184.153 60.5899V33.0361H188.25V57.055H206.513V60.5911H184.153V60.5899Z",
  fill: "#333333"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M237.215 57.0961C234.27 59.6153 230.294 60.8749 225.289 60.8749C220.253 60.8749 216.277 59.6224 213.363 57.1163C210.446 54.6103 208.987 51.1895 208.987 46.8542C208.987 42.5188 210.482 39.1326 213.468 36.6943C216.341 34.3369 220.281 33.1582 225.289 33.1582C230.294 33.1582 234.25 34.3369 237.152 36.6943C240.138 39.1326 241.631 42.52 241.631 46.8542C241.63 51.1622 240.159 54.5746 237.215 57.0961ZM234.334 39.3157C232.202 37.5685 229.184 36.6943 225.289 36.6943C221.39 36.6943 218.389 37.5756 216.284 39.336C214.177 41.0975 213.126 43.6035 213.126 46.8542C213.126 50.1048 214.194 52.6656 216.327 54.5353C218.46 56.4051 221.448 57.3388 225.289 57.3388C229.185 57.3388 232.202 56.411 234.334 54.5556C236.468 52.7001 237.535 50.1334 237.535 46.8542C237.535 43.5762 236.468 41.063 234.334 39.3157Z",
  fill: "#333333"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M273.786 57.0961C270.842 59.6153 266.866 60.8749 261.859 60.8749C256.825 60.8749 252.848 59.6224 249.933 57.1163C247.018 54.6103 245.559 51.1895 245.559 46.8542C245.559 42.5188 247.054 39.1326 250.04 36.6943C252.913 34.3369 256.853 33.1582 261.859 33.1582C266.866 33.1582 270.822 34.3369 273.722 36.6943C276.709 39.1326 278.203 42.52 278.203 46.8542C278.202 51.1622 276.729 54.5746 273.786 57.0961ZM270.906 39.3157C268.772 37.5685 265.756 36.6943 261.859 36.6943C257.962 36.6943 254.961 37.5756 252.854 39.336C250.749 41.0975 249.698 43.6035 249.698 46.8542C249.698 50.1048 250.766 52.6656 252.898 54.5353C255.032 56.4051 258.019 57.3388 261.859 57.3388C265.757 57.3388 268.772 56.411 270.906 54.5556C273.04 52.7001 274.107 50.1334 274.107 46.8542C274.105 43.5762 273.04 41.063 270.906 39.3157Z",
  fill: "#333333"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M308.153 60.5898L292.322 47.2602L287.202 50.7547V60.5898H283.105V33.0361H287.202V46.3253L307.215 33.0361H313.956L295.65 45.1062L313.999 60.5898H308.153Z",
  fill: "#333333"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0V6.07309V88.9031H5.14655H5.90182H88.9364V86.7753V83.3784V73.4968H83.1726V83.3784H5.90182V6.07309H83.1726V20.5874H88.9364V6.07309V4.73501V0H0Z",
  fill: "#86BCC2"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 89,
    viewBox: "0 0 314 89",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.f659b79d.svg";
export { ForwardRef as ReactComponent };